import { onRequestFailure } from './components/AuthHandler';
import './css/UserRefreshForm.css';
import { withFormCache } from './FormCacheResources';

// Define initial state for all form fields to be cached
const initialState = {
  username: "",
};

const UserRefreshForm = ({ 
  token, 
  clientKey, 
  onResponse,
  formState,
  setUsername,
  clearForm
 }) => {

  const sendRefreshRequest = () => {
    const baseUrl = "https://squid-fortress-staging.eleostech.com/api";

    const requestOptions = {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
          "Eleos-Admin-Client-Key": clientKey || "",
        },
      };

    if (!token || !clientKey) {
      alert("Token and Client Key are required in staging.");
      return;
    }

    const requestUrl = `${baseUrl}/v1/users/${formState.username}/updates`;
    const date = new Date();
    const time = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}-`;

    onResponse(`${time}Request Sent to ${requestUrl}`);

    fetch(requestUrl, requestOptions)
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          onRequestFailure();
          throw new Error(`${response.status} ${response.statusText}`);
        }
        const newResponse = `${time}Response: ${response.status}(${response.statusText})`;
        onResponse(newResponse);
      })
      .catch((error) => {
        const newResponse = `${time}Response: Error - ${error.message}`;
        onResponse(newResponse);
      });
  };

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };

  const handleRefreshRequest = () => {
    if (!formState.username.trim()) {
      alert("Please enter a username.");
      return;
    }
    sendRefreshRequest();
  };

  return (
    <div className="user-refresh-form">
      <h3>User Refresh Request</h3>
      <div className="userRefresh-form-container">
        <div className="userRefresh-input-group">
          <label className="userRefresh-input-label">
            Username:
            <input
              name="username"
              type="text"
              value={formState.username}
              onChange={handleUsernameChange}
              className="userRefresh-text-input"
              placeholder="Enter username"
            />
          </label>
          <div className="userRefresh-button-group">
            <button className="userRefresh-send-button" onClick={handleRefreshRequest}>
              SEND
            </button>
            <button type="button" className="userRefresh-clear-button" onClick={() => clearForm()}>
              CLEAR
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withFormCache(UserRefreshForm, 'userRefreshForm', initialState);